import Button from '@zenbusiness/zui/Button';
import CardContent from '@zenbusiness/zui/CardContent';
import Paper from '@zenbusiness/zui/Paper';
import { superstyled } from '@zenbusiness/zui/styles';

export const ExtraInfoCardRoot = superstyled({
  name: 'ExtraInfoCard',
  slot: 'Root',
  tag: Paper,
  styles: ({ theme }) => ({
    backgroundColor: theme.palette.background.grey.dark,
    borderRadius: theme.shape.rounded.lg,

    [theme.breakpoints.up('lg')]: {
      borderRadius: theme.shape.rounded['2xl']
    }
  })
});

export const ExtraInfoCardButton = superstyled({
  name: 'ExtraInfoCard',
  slot: 'Button',
  tag: Button,
  propsAdded: {
    color: 'info',
    size: 'sm',
    variant: 'outlined'
  },
  styles: ({ theme }) => ({
    alignSelf: 'flex-start',
    marginTop: theme.spacing(2)
  })
});

export const ExtraInfoCardContent = superstyled({
  name: 'ExtraInfoCard',
  slot: 'Content',
  tag: CardContent,
  styles: ({ theme }) => ({
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',

    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(3)
    }
  })
});
